import { DestroyRef, Injectable, NgZone } from '@angular/core';
import posthog from 'posthog-js';
import { environment } from 'src/environments/environment';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class PosthogService {
  constructor(
    private ngZone: NgZone,
    private router: Router,
    private destroyRef: DestroyRef,
  ) {
    this.initPostHog();
  }

  private initPostHog(): void {
    if (!environment.POSTHOG_KEY || !environment.POSTHOG_HOST) {
      return;
    }

    this.ngZone.runOutsideAngular(() => {
      posthog.init(environment.POSTHOG_KEY, {
        api_host: environment.POSTHOG_HOST,
        person_profiles: 'identified_only',
        defaults: '2025-05-24',
        enable_heatmaps: true,
        capture_pageview: false,
      });

      this.router.events
        .pipe(
          filter(event => event instanceof NavigationEnd),
          takeUntilDestroyed(this.destroyRef),
        )
        .subscribe(() => {
          posthog.capture('$pageview');
        });
    });
  }
}